var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 0C23.5523 0 24 0.447715 24 1V23C24 23.5523 23.5523 24 23 24H1C0.447716 24 0 23.5523 0 23V1C0 0.447716 0.447715 0 1 0H23ZM5.33333 10.6667H2.66667V2.66667H21.3333V10.6667H13.3333V6.66667C13.3333 6.28889 13.2056 5.97222 12.95 5.71667C12.6944 5.46111 12.3778 5.33333 12 5.33333H6.66667C6.28889 5.33333 5.97222 5.46111 5.71667 5.71667C5.46111 5.97222 5.33333 6.28889 5.33333 6.66667V10.6667ZM10.6667 17.3333V21.3333H2.66667V13.3333H21.3333V21.3333H18.6667V17.3333C18.6667 16.9556 18.5389 16.6389 18.2833 16.3833C18.0278 16.1278 17.7111 16 17.3333 16H12C11.6222 16 11.3056 16.1278 11.05 16.3833C10.7944 16.6389 10.6667 16.9556 10.6667 17.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/redirect-icon.fd877fe48daf1fd738d867177007c205.svg";
export { ForwardRef as ReactComponent };